var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVeryBAd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88.361,
    height: 88.361,
    viewBox: "0 0 88.361 88.361",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1331",
    "data-name": "Group 1331",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_239",
    "data-name": "Ellipse 239",
    cx: 5.771,
    cy: 5.771,
    r: 5.771,
    transform: "translate(21.744 34.624) rotate(-45)",
    fill: "#d92028"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_240",
    "data-name": "Ellipse 240",
    cx: 5.771,
    cy: 5.771,
    r: 5.771,
    transform: "translate(53.152 39.198) rotate(-79.1)",
    fill: "#d92028"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1330",
    "data-name": "Group 1330"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4135",
    "data-name": "Path 4135",
    d: "M4932.891,533.19a44.18,44.18,0,1,0,44.181,44.18,44.23,44.23,0,0,0-44.181-44.18Zm39.225,44.18a39.226,39.226,0,1,1-39.225-39.225,39.27,39.27,0,0,1,39.225,39.225Z",
    transform: "translate(-4888.71 -533.19)",
    fill: "#d92028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4136",
    "data-name": "Path 4136",
    d: "M5053.342,838.472a23.488,23.488,0,0,0-23.462,23.461,2.478,2.478,0,0,0,3.71,2.149,39.774,39.774,0,0,1,19.75-5.269h.2a39.78,39.78,0,0,1,19.555,5.266,2.477,2.477,0,0,0,3.711-2.147,23.488,23.488,0,0,0-23.46-23.461Zm18.008,19.189a44.345,44.345,0,0,0-17.792-3.8h-.219a44.3,44.3,0,0,0-18.007,3.8,18.513,18.513,0,0,1,36.016,0Z",
    transform: "translate(-5009.16 -793.664)",
    fill: "#d92028"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4137",
    "data-name": "Path 4137",
    d: "M5049.109,691.144a1.71,1.71,0,0,1-.481-.069l-12.478-3.583a1.742,1.742,0,1,1,.959-3.349l12.479,3.583a1.743,1.743,0,0,1-.479,3.418Z",
    transform: "translate(-5013.431 -661.929)",
    fill: "#d92028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4138",
    "data-name": "Path 4138",
    d: "M5244.3,691.129a1.743,1.743,0,0,1-.478-3.418l12.478-3.583a1.742,1.742,0,0,1,.959,3.349l-12.479,3.583A1.713,1.713,0,0,1,5244.3,691.129Z",
    transform: "translate(-5190.622 -661.914)",
    fill: "#d92028"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeryBAd);
export default __webpack_public_path__ + "static/media/Very BAd.b70ec079315e9ea14a4afc6f2693d441.svg";
export { ForwardRef as ReactComponent };